<script>
import * as R from 'ramda'

export default {
  props: {
    options: { type: Array, default: () => [] },
    demographicsMap: { type: Array, default: () => [] },
  },
  data() {
    return {
      selected: '',
      demographicsInfos: [
        '<b>Low-income</b> - The count and percentage of students eligible for free or reduced-price lunch or eligible for other public assistance.',
        '<b>English Language Learners</b> – The count and percentage of students whose primary language is one other than English and who are in the process of acquiring English. The terms "English Language Learner," "English Learner," and "Limited English Proficient" (LEP) are used interchangeably.',
        '<b>At Risk</b> – The count and percentage of students identified as being at risk of dropping out of school as defined by TEC §29.081(d) and (d-1).',
      ],
    }
  },
  watch: {
    selected: function(newVal, oldVal) {
      this.$emit('selectDemographic', newVal)
    },
  },
  created() {
    let opt = R.find(v => v.checked, this.options)
    if (opt) {
      this.selected = opt.label
    }
  },
}
</script>

<template>
  <v-list class="single-filter">
    <v-subheader class="reports-filters">Demographic
      <v-menu
        :close-on-content-click="false"
        :nudge-width="300"
        :max-width="300"
        offset-x
        class="info-btn"
      >
        <v-btn
          slot="activator"
          icon
          class="mt-0 mb-0 mr-0"
          aria-label="Demographic definitions">
          <v-icon>info</v-icon>
        </v-btn>
        <v-card>
          <v-card-text
            v-for="(item,index) in demographicsInfos"
            :key="index"
            v-html="item"/>
        </v-card>
      </v-menu>
    </v-subheader>
    <li>
    <v-list-tile-content>
      <v-radio-group
        v-model="selected"
        class="mb-3"
        column>
        <v-radio
          v-for="(option,index) in options"
          :key="index"
          :label="demographicsMap[index]"
          :value="option.label"
          color="grey"
          class="custom-radio"
        />
      </v-radio-group>
      <span class="demographic-tip">To compare demographics, click "Edit Chart Options" and select only one category.</span>
    </v-list-tile-content>
    </li>
  </v-list>
</template>

<style scoped>

.custom-radio.input-group.input-group--active.input-group--selection-controls.radio.grey--text {
  color: #000 !important;
}
.reports-filters {
  font-weight: bolder;
  font-size: 16px;
  font-size: 1.25rem;
  color: #707070;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  margin-bottom: 5px;
  justify-content: space-between;
}
.reports-filters >>> .btn__content {
  color: #253e90;
}
.reports-filters >>> .btn__content::before {
  color: #0390c4;
  opacity: 0.5;
}
.info-btn :hover {
  cursor: pointer;
}
.single-filter {
  position: relative;
}
.single-filter >>> .input-group {
  padding: 0px;
}
.single-filter >>> .input-group__details {
  display: none;
}
.single-filter >>> .list__tile {
  padding: 0px;
}
.single-filter >>> .list__tile--avatar {
  height: 20px;
}
.single-filter >>> .list__tile__content {
  display: block;
}
.single-filter >>> .custom-radio {
  display: flex;
  flex-flow: row-reverse;
  height: auto;
  justify-content: flex-end;
}
.single-filter >>> .custom-radio > label {
  font-size: 14px;
  font-size: 0.875rem;
  white-space: normal;
  line-height: 1.4rem;
  height: auto;
  min-width: unset;
  max-width: 100%;
  position: static;
  left: unset;
  margin-left: 5px;
  padding-top: 2px;
  width: fit-content;
  width: auto; /*IE*/
}
.single-filter >>> .custom-radio > label:hover,
.radio-group [aria-checked='true'] {
  font-weight: bold;
  color: black;
}
.single-filter >>> .custom-radio > .input-group__input {
  flex: 0 0 25px;
  height: 25px;
  min-height: 25px;
}
.demographic-tip {
  font-size: 12px;
  font-size: 0.875rem;
}
</style>
